export const FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_REQUEST = 'FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_REQUEST'
export const FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_SUCCESS = 'FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_SUCCESS'
export const FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_FALUIRE = 'FETCH_LIST_ALL_DELETED_TEMPLATE_TASK_FOR_PROJECT_FALUIRE'

